import React from 'react';
import { faStar as faStarFull } from '@fortawesome/sharp-solid-svg-icons';
import { faStar as faStarOutline } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { IconProp } from '@fortawesome/fontawesome-svg-core';
import { cn } from '~/helpers/utils';

interface StarProps {
  score: number;
  disabled?: boolean
  fontSize?: string
}

const StarRating: React.FC<StarProps> = ({ 
  score,
  disabled,
  fontSize,
}) => (
  <div className="star-rating">
    {[...Array(5)].map((star, index) => {
      index += 1;
      
      if (index <= score) {
        return (
          <span 
            key={index} 
            className={cn(
              'star-rating__star star-rating__star--on',
              disabled ? 'star-rating__star--disabled' : '',
            )}
          >
            <FontAwesomeIcon
              icon={faStarFull as IconProp}
              fontSize={fontSize ?? '16'}
            />
          </span>
        );
      }
      
      if (index > score) {
        return (
          <span key={index} className="star-rating__star star-rating__star--off">
            <FontAwesomeIcon
              icon={faStarOutline as IconProp}
              fontSize={fontSize ?? '16'}
            />
          </span>
        );
      }
    })}
  </div>
);

export default StarRating;
